import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { SERVICE_DETAIL_BANNERS } from '../service-detail-banners';
import { ServiceOrbitVisualComponent } from '../shared/service-orbit-visual/service-orbit-visual.component';


@Component({
  selector: 'app-digital-marketing',
  standalone: true,
  imports: [CommonModule, RouterLink, ServiceOrbitVisualComponent],
  templateUrl: './digital-marketing.component.html',
  styleUrl: './digital-marketing.component.scss',
  host: {
    '[style.--service-banner-image]': 'serviceBannerImage',
  },
})
export class DigitalMarketingComponent {
  readonly serviceBannerImage = SERVICE_DETAIL_BANNERS.digitalMarketing;
}
